import {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {LoginForm} from "../../components/guest/authentication/LoginForm";
import {FormLayout} from "../../components/guest/layout/form/FormLayout";
import Loading from "../../components/loading/Loading";
import {useOAuth2Authentication} from "../../hooks/auth/oAuth2Authentication";
import {useApp} from "../../contexts/AppContext";
import {BannerKind} from "../../types/contexts/AppContext";

export const Login = () => {
    const {t} = useTranslation("login");
    const {search} = useLocation();
    const navigate = useNavigate();
    const {showBanner} = useApp();
    const oauthLogin = useOAuth2Authentication();

    // Google redirects back here with ?code=…; while it is exchanged, show the loader instead of the form.
    const oauthCode = new URLSearchParams(search).get("code");
    const oauthHandled = useRef(false);

    useEffect(() => {
        if (!oauthCode || oauthHandled.current) {
            return;
        }
        oauthHandled.current = true;
        oauthLogin.login({tokenId: oauthCode}).then(signedIn =>
            // On failure drop the used code from the URL, so the form shows (with the error banner) and a refresh
            // does not resend it.
            navigate(signedIn ? "/dashboard" : "/login", {replace: true})
        );
    }, [oauthCode, oauthLogin, navigate]);

    useEffect(() => {
        if (oauthLogin.error) {
            showBanner({kind: BannerKind.ERR, msg: oauthLogin.error});
            oauthLogin.resetState();
        }
    }, [oauthLogin, showBanner]);

    if (oauthCode) {
        return <Loading/>;
    }

    return (
        <FormLayout
            eyebrow={t("login:page-eyebrow")}
            title={<>
                {t("login:page-title-1")}<br/>
                {t("login:page-title-2")}<br/>
                <em>{t("login:page-title-3")}</em>
            </>}
            text={t("login:page-text")}>
            <LoginForm/>
        </FormLayout>
    );
};
